import React from 'react';
import Router from './components/Router';
import Header from './components/Header/Header'


function App() {
  return (
    <div className="App">
   
   
    <Router />
    </div>
  );
}

export default App;
